import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#0d1117',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Arial, sans-serif',
      color: '#ccc',
      textAlign: 'center',
      padding: '2rem',
    }}>
      <img src="/pubsilo.png" alt="PubSilo" style={{ height: '48px', marginBottom: '2rem', opacity: 0.8 }} />
      <div style={{ fontSize: '5rem', fontWeight: '900', color: '#1a4a8a', lineHeight: 1 }}>404</div>
      <h1 style={{ fontSize: '1.4rem', fontWeight: '700', margin: '1rem 0 0.5rem', color: '#eee' }}>
        Page not found
      </h1>
      <p style={{ color: '#888', marginBottom: '2rem', maxWidth: '360px', lineHeight: 1.6 }}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to="/"
        style={{
          padding: '0.7rem 1.75rem',
          background: '#1a4a8a',
          color: '#fff',
          textDecoration: 'none',
          borderRadius: '6px',
          fontWeight: '700',
          fontSize: '0.9rem',
        }}
      >
        Back to PubSilo
      </Link>
    </div>
  );
}
